import React from 'react';
import PropTypes from 'prop-types';
import s from './ImageText.module.scss';
import Image from '../Image/Image';
import classNames from 'classnames';
import Icon from '../Icon/Icon';

const ImageText = ({
    image,
    icon,
    textNoIcon = '',
    size = 'Large',
    isSquare = false,
    hasBorder = false,
    description = '',
    hideIfZero = false,
}) => {
    if (hideIfZero) {
        if (description.startsWith('0')) {
            return null;
        }
    }

    const classes = classNames(
        s.Root,
        s[`Root--${size}`],
        { [s['Root--Square']]: isSquare },
        { [s['Root--Border']]: hasBorder },
        { [s['Root--NoImage']]: !image && !icon && !textNoIcon }
    );

    return (
        <div className={classes}>
            <div className={s.Container}>
                {image && (
                    <div className={s.Image}>
                        <Image useCover={false} useCaption={false} {...image} />
                    </div>
                )}
                {icon && !image && !textNoIcon && (
                    <div className={s.Image}>
                        <Icon name={icon} />
                    </div>
                )}
                {!icon && !image && textNoIcon && (
                    <div title={textNoIcon} className={s.TextNoIcon}>
                        {textNoIcon}
                    </div>
                )}
                <div className={s.Text}>
                    <span className={s.Description}>{description}</span>
                </div>
            </div>
        </div>
    );
};

ImageText.propTypes = {
    image: PropTypes.object,
    maxHeight: PropTypes.string,
    description: PropTypes.string,
};

export default ImageText;
